import { render, staticRenderFns } from "./pos-layout.vue?vue&type=template&id=3413a2a6&scoped=true&"
import script from "./pos-layout.vue?vue&type=script&lang=ts&"
export * from "./pos-layout.vue?vue&type=script&lang=ts&"
import style0 from "./pos-layout.vue?vue&type=style&index=0&id=3413a2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3413a2a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
